import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { RadioButton, RadioGroup, StackItem, Tag, Typography } from '@optimus-web/core';
import { useGetInfoRowProps } from '../BillCardList/BillCard/AccountsInfoSection/utils';

interface EditAssociatedAccountProps {
    associatedAccountId: string;
    editMode: 'remove' | 'change' | undefined;
    onEditModeSelection: (value: 'remove' | 'change') => void;
}

export const EditAssociatedAccount = ({
    associatedAccountId,
    editMode,
    onEditModeSelection,
}: EditAssociatedAccountProps) => {
    const { iconValue, name } = useGetInfoRowProps({ accountId: associatedAccountId });
    return (
        <>
            <LocalizedParagraph textKey={TextKey.AssociateBillCurrentAccount} variant="secondary" />
            <StackItem>
                <Tag leadingIcon={iconValue || undefined}>{name}</Tag>
            </StackItem>
            <StackItem>
                <Typography textStyle="bodyLarge" as="div">
                    <LocalizedText textKey={TextKey.AssociateBillAccountEditSelection} />
                </Typography>
                <RadioGroup
                    onChange={(event) => {
                        onEditModeSelection(event.target.value as 'remove' | 'change');
                    }}
                    value={editMode}
                >
                    <RadioButton
                        label={<LocalizedText textKey={TextKey.AssociateBillRemoveAccount} />}
                        value="remove"
                    />
                    <RadioButton
                        label={<LocalizedText textKey={TextKey.AssociateBillChangeAccount} />}
                        value="change"
                    />
                </RadioGroup>
            </StackItem>
        </>
    );
};
